import React from 'react';
import SearchBar from './SearchBar';
import { useLanguage } from '../context/LanguageContext';
import './Hero.css';

export default function Hero() {
  const { t } = useLanguage();

  return (
    <section className="hero">
      <div className="hero__videoWrapper" aria-hidden="true">
        <video
          className="hero__video"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
        >
          <source src="/videos/hero-drone.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="hero__overlay" aria-hidden="true" />
      <div className="hero__orb hero__orb--1" />
      <div className="hero__orb hero__orb--2" />
      <div className="hero__orb hero__orb--3" />

      <div className="hero__content">
        <h1 className="hero__title animate-fade-up delay-2">
          {t('home.hero.titleA')} <span className="hero__titleAccent">{t('home.hero.titleB')}</span><br />
          {t('home.hero.titleC')}
        </h1>

        <div className="animate-fade-up delay-3" style={{ marginBottom: 28 }}>
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            background: 'rgba(255,255,255,0.15)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            border: '1px solid rgba(255,255,255,0.25)',
            borderRadius: 0,
            padding: '10px 22px',
            fontSize: 13,
            fontWeight: 500,
            color: 'white',
            letterSpacing: 0.3,
          }}>
            {t('home.hero.subtitle')}
          </span>
        </div>

        <div className="animate-fade-up delay-4">
          <SearchBar variant="hero" />
        </div>
      </div>
    </section>
  );
}
